// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Ksbe","footer":"ModalError_footer__1wM7l"};